import { render, staticRenderFns } from "./NewIcon.vue?vue&type=template&id=577232cc"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577232cc')) {
      api.createRecord('577232cc', component.options)
    } else {
      api.reload('577232cc', component.options)
    }
    module.hot.accept("./NewIcon.vue?vue&type=template&id=577232cc", function () {
      api.rerender('577232cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/NewIcon.vue"
export default component.exports